'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var debug = require('debug');

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var errcode = require('err-code');

var _require2 = require('it-pipe'),
    pipe = _require2.pipe;

var _require3 = require('p-queue'),
    Queue = _require3.default;

var MulticodecTopology = require('../topology/multicodec-topology');

var _require4 = require('./errors'),
    codes = _require4.codes;

var _require5 = require('./message/rpc'),
    RPC = _require5.RPC;

var PeerStreams = require('./peer-streams');

var _require6 = require('./signature-policy'),
    SignaturePolicy = _require6.SignaturePolicy;

var utils = require('./utils');

var _require7 = require('./message/sign'),
    signMessage = _require7.signMessage,
    verifySignature = _require7.verifySignature;
/**
 * @typedef {any} Libp2p
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('bl')} BufferList
 * @typedef {import('../stream-muxer/types').MuxedStream} MuxedStream
 * @typedef {import('../connection/connection')} Connection
 * @typedef {import('./signature-policy').SignaturePolicyType} SignaturePolicyType
 * @typedef {import('./message/rpc').IRPC} IRPC
 * @typedef {import('./message/rpc').RPC.SubOpts} RPCSubOpts
 * @typedef {import('./message/rpc').RPC.Message} RPCMessage
 */

/**
 * @typedef {Object} InMessage
 * @property {string} [from]
 * @property {string} receivedFrom
 * @property {string[]} topicIDs
 * @property {Uint8Array} [seqno]
 * @property {Uint8Array} data
 * @property {Uint8Array} [signature]
 * @property {Uint8Array} [key]
 *
 * @typedef {Object} PubsubProperties
 * @property {string} debugName - log namespace
 * @property {Array<string>|string} multicodecs - protocol identificers to connect
 * @property {Libp2p} libp2p
 *
 * @typedef {Object} PubsubOptions
 * @property {SignaturePolicyType} [globalSignaturePolicy = SignaturePolicy.StrictSign] - defines how signatures should be handled
 * @property {boolean} [canRelayMessage = false] - if can relay messages not subscribed
 * @property {boolean} [emitSelf = false] - if publish should emit to self, if subscribed
 * @property {number} [messageProcessingConcurrency = 10] - handle this many incoming pubsub messages concurrently
 */

/**
 * PubsubBaseProtocol handles the peers and connections logic for pubsub routers
 * and specifies the API that pubsub routers should have.
 */


var PubsubBaseProtocol = /*#__PURE__*/function (_EventEmitter) {
  _inherits(PubsubBaseProtocol, _EventEmitter);

  var _super = _createSuper(PubsubBaseProtocol);

  /**
   * @param {PubsubProperties & PubsubOptions} props
   * @abstract
   */
  function PubsubBaseProtocol(_ref) {
    var _this;

    var debugName = _ref.debugName,
        multicodecs = _ref.multicodecs,
        libp2p = _ref.libp2p,
        _ref$globalSignatureP = _ref.globalSignaturePolicy,
        globalSignaturePolicy = _ref$globalSignatureP === void 0 ? SignaturePolicy.StrictSign : _ref$globalSignatureP,
        _ref$canRelayMessage = _ref.canRelayMessage,
        canRelayMessage = _ref$canRelayMessage === void 0 ? false : _ref$canRelayMessage,
        _ref$emitSelf = _ref.emitSelf,
        emitSelf = _ref$emitSelf === void 0 ? false : _ref$emitSelf,
        _ref$messageProcessin = _ref.messageProcessingConcurrency,
        messageProcessingConcurrency = _ref$messageProcessin === void 0 ? 10 : _ref$messageProcessin;

    _classCallCheck(this, PubsubBaseProtocol);

    if (typeof debugName !== 'string') {
      throw new Error('a debugname `string` is required');
    }

    if (!multicodecs) {
      throw new Error('multicodecs are required');
    }

    if (!libp2p) {
      throw new Error('libp2p is required');
    }

    _this = _super.call(this);
    _this.log = Object.assign(debug(debugName), {
      err: debug("".concat(debugName, ":error"))
    });
    /**
     * @type {Array<string>}
     */

    _this.multicodecs = utils.ensureArray(multicodecs);
    _this._libp2p = libp2p;
    _this.registrar = libp2p.registrar;
    /**
     * @type {PeerId}
     */

    _this.peerId = libp2p.peerId;
    _this.started = false;
    /**
     * Map of topics to which peers are subscribed to
     *
     * @type {Map<string, Set<string>>}
     */

    _this.topics = new Map();
    /**
     * List of our subscriptions
     *
     * @type {Set<string>}
     */

    _this.subscriptions = new Set();
    /**
     * Map of peer streams
     *
     * @type {Map<string, import('./peer-streams')>}
     */

    _this.peers = new Map(); // validate signature policy

    if (!SignaturePolicy[globalSignaturePolicy]) {
      throw errcode(new Error('Invalid global signature policy'), codes.ERR_INVALID_SIGNATURE_POLICY);
    }
    /**
     * The signature policy to follow by default
     *
     * @type {string}
     */


    _this.globalSignaturePolicy = globalSignaturePolicy;
    /**
     * If router can relay received messages, even if not subscribed
     *
     * @type {boolean}
     */

    _this.canRelayMessage = canRelayMessage;
    /**
     * if publish should emit to self, if subscribed
     *
     * @type {boolean}
     */

    _this.emitSelf = emitSelf;
    /**
     * Topic validator function
     *
     * @typedef {function(string, InMessage): Promise<void>} validator
     */

    /**
     * Topic validator map
     *
     * Keyed by topic
     * Topic validators are functions with the following input:
     *
     * @type {Map<string, validator>}
     */

    _this.topicValidators = new Map();
    /**
     * @type {Queue}
     */

    _this.queue = new Queue({
      concurrency: messageProcessingConcurrency
    });
    _this._registrarId = undefined;
    _this._onIncomingStream = _this._onIncomingStream.bind(_assertThisInitialized(_this));
    _this._onPeerConnected = _this._onPeerConnected.bind(_assertThisInitialized(_this));
    _this._onPeerDisconnected = _this._onPeerDisconnected.bind(_assertThisInitialized(_this));
    return _this;
  } // LIFECYCLE METHODS

  /**
   * Register the pubsub protocol onto the libp2p node.
   *
   * @returns {void}
   */


  _createClass(PubsubBaseProtocol, [{
    key: "start",
    value: function start() {
      if (this.started) {
        return;
      }

      this.log('starting'); // Incoming streams
      // Called after a peer dials us

      this.registrar.handle(this.multicodecs, this._onIncomingStream); // register protocol with topology
      // Topology callbacks called on connection manager changes

      var topology = new MulticodecTopology({
        multicodecs: this.multicodecs,
        handlers: {
          onConnect: this._onPeerConnected,
          onDisconnect: this._onPeerDisconnected
        }
      });
      this._registrarId = this.registrar.register(topology);
      this.log('started');
      this.started = true;
    }
    /**
     * Unregister the pubsub protocol and the streams with other peers will be closed.
     *
     * @returns {void}
     */

  }, {
    key: "stop",
    value: function stop() {
      if (!this.started) {
        return;
      } // unregister protocol and handlers


      this.registrar.unregister(this._registrarId);
      this.log('stopping');
      this.peers.forEach(function (peerStreams) {
        return peerStreams.close();
      });
      this.peers = new Map();
      this.subscriptions = new Set();
      this.started = false;
      this.log('stopped');
    }
    /**
     * On an inbound stream opened.
     *
     * @protected
     * @param {Object} props
     * @param {string} props.protocol
     * @param {MuxedStream} props.stream
     * @param {Connection} props.connection - connection
     */

  }, {
    key: "_onIncomingStream",
    value: function _onIncomingStream(_ref2) {
      var protocol = _ref2.protocol,
          stream = _ref2.stream,
          connection = _ref2.connection;
      var peerId = connection.remotePeer;
      var idB58Str = peerId.toB58String();

      var peer = this._addPeer(peerId, protocol);

      var inboundStream = peer.attachInboundStream(stream);

      this._processMessages(idB58Str, inboundStream, peer);
    }
    /**
     * Registrar notifies an established connection with pubsub protocol.
     *
     * @protected
     * @param {PeerId} peerId - remote peer-id
     * @param {Connection} conn - connection to the peer
     */

  }, {
    key: "_onPeerConnected",
    value: function () {
      var _onPeerConnected2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId, conn) {
        var idB58Str, _yield$conn$newStream, stream, protocol, peer;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                idB58Str = peerId.toB58String();
                this.log('connected', idB58Str);
                _context.prev = 2;
                _context.next = 5;
                return conn.newStream(this.multicodecs);

              case 5:
                _yield$conn$newStream = _context.sent;
                stream = _yield$conn$newStream.stream;
                protocol = _yield$conn$newStream.protocol;
                peer = this._addPeer(peerId, protocol);
                _context.next = 11;
                return peer.attachOutboundStream(stream);

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);
                this.log.err(_context.t0);

              case 16:
                // Immediately send my own subscriptions to the newly established conn
                this._sendSubscriptions(idB58Str, Array.from(this.subscriptions), true);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 13]]);
      }));

      function _onPeerConnected(_x, _x2) {
        return _onPeerConnected2.apply(this, arguments);
      }

      return _onPeerConnected;
    }()
    /**
     * Registrar notifies a closing connection with pubsub protocol.
     *
     * @protected
     * @param {PeerId} peerId - peerId
     * @param {Error} [err] - error for connection end
     */

  }, {
    key: "_onPeerDisconnected",
    value: function _onPeerDisconnected(peerId, err) {
      var idB58Str = peerId.toB58String();
      this.log('connection ended', idB58Str, err ? err.message : '');

      this._removePeer(peerId);
    }
    /**
     * Notifies the router that a peer has been connected
     *
     * @protected
     * @param {PeerId} peerId
     * @param {string} protocol
     * @returns {PeerStreams}
     */

  }, {
    key: "_addPeer",
    value: function _addPeer(peerId, protocol) {
      var _this2 = this;

      var id = peerId.toB58String();
      var existing = this.peers.get(id); // If peer streams already exists, do nothing

      if (existing) {
        return existing;
      } // else create a new peer streams


      this.log('new peer', id);
      var peerStreams = new PeerStreams({
        id: peerId,
        protocol: protocol
      });
      this.peers.set(id, peerStreams);
      peerStreams.once('close', function () {
        return _this2._removePeer(peerId);
      });
      return peerStreams;
    }
    /**
     * Notifies the router that a peer has been disconnected.
     *
     * @protected
     * @param {PeerId} peerId
     * @returns {PeerStreams | undefined}
     */

  }, {
    key: "_removePeer",
    value: function _removePeer(peerId) {
      if (!peerId) return;
      var id = peerId.toB58String();
      var peerStreams = this.peers.get(id);
      if (!peerStreams) return; // close peer streams

      peerStreams.removeAllListeners();
      peerStreams.close(); // delete peer streams

      this.log('delete peer', id);
      this.peers.delete(id); // remove peer from topics map

      var _iterator2 = _createForOfIteratorHelper(this.topics.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var peers = _step2.value;
          peers.delete(id);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return peerStreams;
    } // MESSAGE METHODS

    /**
     * Responsible for processing each RPC message received by other peers.
     *
     * @param {string} idB58Str - peer id string in base58
     * @param {AsyncIterable<Uint8Array|BufferList>} stream - inbound stream
     * @param {PeerStreams} peerStreams - PubSub peer
     * @returns {Promise<void>}
     */

  }, {
    key: "_processMessages",
    value: function () {
      var _processMessages2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(idB58Str, stream, peerStreams) {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return pipe(stream, /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(source) {
                    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _iteratorAbruptCompletion = false;
                            _didIteratorError = false;
                            _context3.prev = 2;

                            _loop = function _loop() {
                              var data = _step.value;
                              var rpcBytes = data instanceof Uint8Array ? data : data.slice();

                              var rpcMsg = _this3._decodeRpc(rpcBytes) // Since _processRpc may be overridden entirely in unsafe ways,
                              // the simplest/safest option here is to wrap in a function and capture all errors
                              // to prevent a top-level unhandled exception
                              // This processing of rpc messages should happen without awaiting full validation/execution of prior messages
                              ;

                              _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        _context2.prev = 0;
                                        _context2.next = 3;
                                        return _this3._processRpc(idB58Str, peerStreams, rpcMsg);

                                      case 3:
                                        _context2.next = 8;
                                        break;

                                      case 5:
                                        _context2.prev = 5;
                                        _context2.t0 = _context2["catch"](0);

                                        _this3.log.err(_context2.t0);

                                      case 8:
                                      case "end":
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2, null, [[0, 5]]);
                              }))();
                            };

                            _iterator = _asyncIterator(source);

                          case 5:
                            _context3.next = 7;
                            return _iterator.next();

                          case 7:
                            if (!(_iteratorAbruptCompletion = !(_step = _context3.sent).done)) {
                              _context3.next = 12;
                              break;
                            }

                            _loop();

                          case 9:
                            _iteratorAbruptCompletion = false;
                            _context3.next = 5;
                            break;

                          case 12:
                            _context3.next = 18;
                            break;

                          case 14:
                            _context3.prev = 14;
                            _context3.t0 = _context3["catch"](2);
                            _didIteratorError = true;
                            _iteratorError = _context3.t0;

                          case 18:
                            _context3.prev = 18;
                            _context3.prev = 19;

                            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                              _context3.next = 23;
                              break;
                            }

                            _context3.next = 23;
                            return _iterator.return();

                          case 23:
                            _context3.prev = 23;

                            if (!_didIteratorError) {
                              _context3.next = 26;
                              break;
                            }

                            throw _iteratorError;

                          case 26:
                            return _context3.finish(23);

                          case 27:
                            return _context3.finish(18);

                          case 28:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, null, [[2, 14, 18, 28], [19,, 23, 27]]);
                  }));

                  return function (_x6) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 3:
                _context4.next = 8;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4["catch"](0);

                this._onPeerDisconnected(peerStreams.id, _context4.t0);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 5]]);
      }));

      function _processMessages(_x3, _x4, _x5) {
        return _processMessages2.apply(this, arguments);
      }

      return _processMessages;
    }()
    /**
     * Handles an rpc request from a peer
     *
     * @param {string} idB58Str
     * @param {PeerStreams} peerStreams
     * @param {RPC} rpc
     * @returns {Promise<boolean>}
     */

  }, {
    key: "_processRpc",
    value: function () {
      var _processRpc2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(idB58Str, peerStreams, rpc) {
        var _this4 = this;

        var subs, msgs;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.log('rpc from', idB58Str);
                subs = rpc.subscriptions;
                msgs = rpc.msgs;

                if (subs.length) {
                  // update peer subscriptions
                  subs.forEach(function (subOpt) {
                    _this4._processRpcSubOpt(idB58Str, subOpt);
                  });
                  this.emit('pubsub:subscription-change', peerStreams.id, subs);
                }

                if (this._acceptFrom(idB58Str)) {
                  _context6.next = 7;
                  break;
                }

                this.log('received message from unacceptable peer %s', idB58Str);
                return _context6.abrupt("return", false);

              case 7:
                if (msgs.length) {
                  this.queue.addAll(msgs.map(function (message) {
                    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                      var msg;
                      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              if (_this4.canRelayMessage || message.topicIDs && message.topicIDs.some(function (topic) {
                                return _this4.subscriptions.has(topic);
                              })) {
                                _context5.next = 3;
                                break;
                              }

                              _this4.log('received message we didn\'t subscribe to. Dropping.');

                              return _context5.abrupt("return");

                            case 3:
                              _context5.prev = 3;
                              msg = utils.normalizeInRpcMessage(message, idB58Str);
                              _context5.next = 7;
                              return _this4._processRpcMessage(msg);

                            case 7:
                              _context5.next = 12;
                              break;

                            case 9:
                              _context5.prev = 9;
                              _context5.t0 = _context5["catch"](3);

                              _this4.log.err(_context5.t0);

                            case 12:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5, null, [[3, 9]]);
                    }));
                  }));
                }

                return _context6.abrupt("return", true);

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _processRpc(_x7, _x8, _x9) {
        return _processRpc2.apply(this, arguments);
      }

      return _processRpc;
    }()
    /**
     * Handles a subscription change from a peer
     *
     * @param {string} id
     * @param {RPC.ISubOpts} subOpt
     */

  }, {
    key: "_processRpcSubOpt",
    value: function _processRpcSubOpt(id, subOpt) {
      var t = subOpt.topicID;

      if (!t) {
        return;
      }

      var topicSet = this.topics.get(t);

      if (!topicSet) {
        topicSet = new Set();
        this.topics.set(t, topicSet);
      }

      if (subOpt.subscribe) {
        // subscribe peer to new topic
        topicSet.add(id);
      } else {
        // unsubscribe from existing topic
        topicSet.delete(id);
      }
    }
    /**
     * Handles an message from a peer
     *
     * @param {InMessage} msg
     * @returns {Promise<void>}
     */

  }, {
    key: "_processRpcMessage",
    value: function () {
      var _processRpcMessage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(msg) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this.peerId.toB58String() === msg.from && !this.emitSelf)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                _context7.prev = 2;
                _context7.next = 5;
                return this.validate(msg);

              case 5:
                _context7.next = 11;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](2);
                this.log('Message is invalid, dropping it. %O', _context7.t0);
                return _context7.abrupt("return");

              case 11:
                // Emit to self
                this._emitMessage(msg);

                return _context7.abrupt("return", this._publish(utils.normalizeOutRpcMessage(msg)));

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 7]]);
      }));

      function _processRpcMessage(_x10) {
        return _processRpcMessage2.apply(this, arguments);
      }

      return _processRpcMessage;
    }()
    /**
     * Emit a message from a peer
     *
     * @param {InMessage} message
     */

  }, {
    key: "_emitMessage",
    value: function _emitMessage(message) {
      var _this5 = this;

      message.topicIDs.forEach(function (topic) {
        if (_this5.subscriptions.has(topic)) {
          _this5.emit(topic, message);
        }
      });
    }
    /**
     * The default msgID implementation
     * Child class can override this.
     *
     * @param {InMessage} msg - the message object
     * @returns {Promise<Uint8Array> | Uint8Array} message id as bytes
     */

  }, {
    key: "getMsgId",
    value: function getMsgId(msg) {
      var signaturePolicy = this.globalSignaturePolicy;

      switch (signaturePolicy) {
        case SignaturePolicy.StrictSign:
          // @ts-ignore seqno is optional in protobuf definition but it will exist
          return utils.msgId(msg.from, msg.seqno);

        case SignaturePolicy.StrictNoSign:
          return utils.noSignMsgId(msg.data);

        default:
          throw errcode(new Error('Cannot get message id: unhandled signature policy: ' + signaturePolicy), codes.ERR_UNHANDLED_SIGNATURE_POLICY);
      }
    }
    /**
     * Whether to accept a message from a peer
     * Override to create a graylist
     *
     * @param {string} id
     * @returns {boolean}
     */

  }, {
    key: "_acceptFrom",
    value: function _acceptFrom(id) {
      return true;
    }
    /**
     * Decode Uint8Array into an RPC object.
     * This can be override to use a custom router protobuf.
     *
     * @param {Uint8Array} bytes
     * @returns {RPC}
     */

  }, {
    key: "_decodeRpc",
    value: function _decodeRpc(bytes) {
      return RPC.decode(bytes);
    }
    /**
     * Encode RPC object into a Uint8Array.
     * This can be override to use a custom router protobuf.
     *
     * @param {IRPC} rpc
     * @returns {Uint8Array}
     */

  }, {
    key: "_encodeRpc",
    value: function _encodeRpc(rpc) {
      return RPC.encode(rpc).finish();
    }
    /**
     * Send an rpc object to a peer
     *
     * @param {string} id - peer id
     * @param {IRPC} rpc
     * @returns {void}
     */

  }, {
    key: "_sendRpc",
    value: function _sendRpc(id, rpc) {
      var peerStreams = this.peers.get(id);

      if (!peerStreams || !peerStreams.isWritable) {
        var msg = "Cannot send RPC to ".concat(id, " as there is no open stream to it available");
        this.log.err(msg);
        return;
      }

      peerStreams.write(this._encodeRpc(rpc));
    }
    /**
     * Send subscroptions to a peer
     *
     * @param {string} id - peer id
     * @param {string[]} topics
     * @param {boolean} subscribe - set to false for unsubscriptions
     * @returns {void}
     */

  }, {
    key: "_sendSubscriptions",
    value: function _sendSubscriptions(id, topics, subscribe) {
      return this._sendRpc(id, {
        subscriptions: topics.map(function (t) {
          return {
            topicID: t,
            subscribe: subscribe
          };
        })
      });
    }
    /**
     * Validates the given message. The signature will be checked for authenticity.
     * Throws an error on invalid messages
     *
     * @param {InMessage} message
     * @returns {Promise<void>}
     */

  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(message) {
        var signaturePolicy, _iterator3, _step3, topic, validatorFn;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                // eslint-disable-line require-await
                signaturePolicy = this.globalSignaturePolicy;
                _context8.t0 = signaturePolicy;
                _context8.next = _context8.t0 === SignaturePolicy.StrictNoSign ? 4 : _context8.t0 === SignaturePolicy.StrictSign ? 13 : 22;
                break;

              case 4:
                if (!message.from) {
                  _context8.next = 6;
                  break;
                }

                throw errcode(new Error('StrictNoSigning: from should not be present'), codes.ERR_UNEXPECTED_FROM);

              case 6:
                if (!message.signature) {
                  _context8.next = 8;
                  break;
                }

                throw errcode(new Error('StrictNoSigning: signature should not be present'), codes.ERR_UNEXPECTED_SIGNATURE);

              case 8:
                if (!message.key) {
                  _context8.next = 10;
                  break;
                }

                throw errcode(new Error('StrictNoSigning: key should not be present'), codes.ERR_UNEXPECTED_KEY);

              case 10:
                if (!message.seqno) {
                  _context8.next = 12;
                  break;
                }

                throw errcode(new Error('StrictNoSigning: seqno should not be present'), codes.ERR_UNEXPECTED_SEQNO);

              case 12:
                return _context8.abrupt("break", 23);

              case 13:
                if (message.signature) {
                  _context8.next = 15;
                  break;
                }

                throw errcode(new Error('StrictSigning: Signing required and no signature was present'), codes.ERR_MISSING_SIGNATURE);

              case 15:
                if (message.seqno) {
                  _context8.next = 17;
                  break;
                }

                throw errcode(new Error('StrictSigning: Signing required and no seqno was present'), codes.ERR_MISSING_SEQNO);

              case 17:
                _context8.next = 19;
                return verifySignature(message);

              case 19:
                if (_context8.sent) {
                  _context8.next = 21;
                  break;
                }

                throw errcode(new Error('StrictSigning: Invalid message signature'), codes.ERR_INVALID_SIGNATURE);

              case 21:
                return _context8.abrupt("break", 23);

              case 22:
                throw errcode(new Error('Cannot validate message: unhandled signature policy: ' + signaturePolicy), codes.ERR_UNHANDLED_SIGNATURE_POLICY);

              case 23:
                _iterator3 = _createForOfIteratorHelper(message.topicIDs);
                _context8.prev = 24;

                _iterator3.s();

              case 26:
                if ((_step3 = _iterator3.n()).done) {
                  _context8.next = 34;
                  break;
                }

                topic = _step3.value;
                validatorFn = this.topicValidators.get(topic);

                if (!validatorFn) {
                  _context8.next = 32;
                  break;
                }

                _context8.next = 32;
                return validatorFn(topic, message);

              case 32:
                _context8.next = 26;
                break;

              case 34:
                _context8.next = 39;
                break;

              case 36:
                _context8.prev = 36;
                _context8.t1 = _context8["catch"](24);

                _iterator3.e(_context8.t1);

              case 39:
                _context8.prev = 39;

                _iterator3.f();

                return _context8.finish(39);

              case 42:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[24, 36, 39, 42]]);
      }));

      function validate(_x11) {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
    /**
     * Normalizes the message and signs it, if signing is enabled.
     * Should be used by the routers to create the message to send.
     *
     * @protected
     * @param {InMessage} message
     * @returns {Promise<InMessage>}
     */

  }, {
    key: "_buildMessage",
    value: function _buildMessage(message) {
      var signaturePolicy = this.globalSignaturePolicy;

      switch (signaturePolicy) {
        case SignaturePolicy.StrictSign:
          message.from = this.peerId.toB58String();
          message.seqno = utils.randomSeqno();
          return signMessage(this.peerId, message);

        case SignaturePolicy.StrictNoSign:
          return Promise.resolve(message);

        default:
          throw errcode(new Error('Cannot build message: unhandled signature policy: ' + signaturePolicy), codes.ERR_UNHANDLED_SIGNATURE_POLICY);
      }
    } // API METHODS

    /**
     * Get a list of the peer-ids that are subscribed to one topic.
     *
     * @param {string} topic
     * @returns {Array<string>}
     */

  }, {
    key: "getSubscribers",
    value: function getSubscribers(topic) {
      if (!this.started) {
        throw errcode(new Error('not started yet'), 'ERR_NOT_STARTED_YET');
      }

      if (!topic || typeof topic !== 'string') {
        throw errcode(new Error('a string topic must be provided'), 'ERR_NOT_VALID_TOPIC');
      }

      var peersInTopic = this.topics.get(topic);

      if (!peersInTopic) {
        return [];
      }

      return Array.from(peersInTopic);
    }
    /**
     * Publishes messages to all subscribed peers
     *
     * @param {string} topic
     * @param {Uint8Array} message
     * @returns {Promise<void>}
     */

  }, {
    key: "publish",
    value: function () {
      var _publish2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(topic, message) {
        var from, msgObject, outMsg, msg;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this.started) {
                  _context9.next = 2;
                  break;
                }

                throw new Error('Pubsub has not started');

              case 2:
                this.log('publish', topic, message);
                from = this.peerId.toB58String();
                msgObject = {
                  receivedFrom: from,
                  data: message,
                  topicIDs: [topic]
                }; // ensure that the message follows the signature policy

                _context9.next = 7;
                return this._buildMessage(msgObject);

              case 7:
                outMsg = _context9.sent;
                // @ts-ignore different type as from is converted
                msg = utils.normalizeInRpcMessage(outMsg); // Emit to self if I'm interested and emitSelf enabled

                this.emitSelf && this._emitMessage(msg); // send to all the other peers

                _context9.next = 12;
                return this._publish(msg);

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function publish(_x12, _x13) {
        return _publish2.apply(this, arguments);
      }

      return publish;
    }()
    /**
     * Overriding the implementation of publish should handle the appropriate algorithms for the publish/subscriber implementation.
     * For example, a Floodsub implementation might simply publish each message to each topic for every peer
     *
     * @abstract
     * @param {InMessage|RPCMessage} message
     * @returns {Promise<void>}
     *
     */

  }, {
    key: "_publish",
    value: function _publish(message) {
      throw errcode(new Error('publish must be implemented by the subclass'), 'ERR_NOT_IMPLEMENTED');
    }
    /**
     * Subscribes to a given topic.
     *
     * @abstract
     * @param {string} topic
     * @returns {void}
     */

  }, {
    key: "subscribe",
    value: function subscribe(topic) {
      var _this6 = this;

      if (!this.started) {
        throw new Error('Pubsub has not started');
      }

      if (!this.subscriptions.has(topic)) {
        this.subscriptions.add(topic);
        this.peers.forEach(function (_, id) {
          return _this6._sendSubscriptions(id, [topic], true);
        });
      }
    }
    /**
     * Unsubscribe from the given topic.
     *
     * @param {string} topic
     * @returns {void}
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(topic) {
      var _this7 = this;

      if (!this.started) {
        throw new Error('Pubsub is not started');
      }

      if (this.subscriptions.has(topic) && this.listenerCount(topic) === 0) {
        this.subscriptions.delete(topic);
        this.peers.forEach(function (_, id) {
          return _this7._sendSubscriptions(id, [topic], false);
        });
      }
    }
    /**
     * Get the list of topics which the peer is subscribed to.
     *
     * @returns {Array<string>}
     */

  }, {
    key: "getTopics",
    value: function getTopics() {
      if (!this.started) {
        throw new Error('Pubsub is not started');
      }

      return Array.from(this.subscriptions);
    }
  }]);

  return PubsubBaseProtocol;
}(EventEmitter);

PubsubBaseProtocol.utils = utils;
PubsubBaseProtocol.SignaturePolicy = SignaturePolicy;
module.exports = PubsubBaseProtocol;